@if (shunters?.prices?.length > 1) {
    <div>
        <table class="mb-4">
            <tr>
                @for (dataShunter of getShuntersArray(shunters.data); track dataShunter) {
                    <td>
                        <div class="shunter-data"
                             [ngStyle]="{'width': !dataShunter ? 'auto':'60px'}">{{ dataShunter }}
                        </div>
                    </td>
                }
            </tr>
            <tr>
                @for (dataShunter of getShuntersArray(shunters.data); track dataShunter; let index = $index) {
                    <td>
                        @if (dataShunter !== '') {
                            <div class="vertical-line"></div>
                        } @else {
                            <div [ngClass]="{'price': !isSelectShunter(getPrice(shunters.prices, index)), 'selected-price': isSelectShunter(getPrice(shunters.prices, index))}">{{ priceFormatService.get(getPrice(shunters.prices, index)).replace(' ', '') }}</div>
                        }
                    </td>
                }
            </tr>
            <tr>
                <td [attr.colspan]="getShuntersArray(shunters.data).length">
                    <div class="w-100 gradient"></div>
                </td>
            </tr>
        </table>
    </div>
}

@if (shunters?.prices?.length == 1) {
    <div>
        <table class="mb-4">
            <tr>
                @for (dataShunter of getShuntersArray(shunters.data); track dataShunter; let index = $index) {
                    <td>
                        @if (dataShunter != '' && (index == 0 || index != 0)) {
                            <div class="shunter-data">{{ dataShunter }}</div>
                        }
                    </td>
                }
            </tr>
            <tr>
                @for (dataShunter of getShuntersArray(shunters.data); track dataShunter; let index = $index) {
                    <td>
                        @if (dataShunter != '') {
                            <div class="vertical-line" style="height: 30px;"></div>
                        }
                        @if (dataShunter == '') {
                            <div class="size-handler">
                                {{ customPrice ? priceFormatService.get((customPrice * 1.2).toString()).replace(' ', '') : priceFormatService.get(getPrice(shunters.prices, index)).replace(' ', '') }}
                            </div>
                        }
                        @if (dataShunter != '') {
                            <div class="vertical-line" style="height: 30px;"></div>
                        }
                    </td>
                }
            </tr>
            <tr>
                <td [attr.colspan]="getShuntersArray(shunters.data).length">
                    <div class="w-100 gradient"></div>
                </td>
            </tr>
        </table>
    </div>
}
